import React, { useEffect, useState } from 'react';
import localforage from 'localforage';
import { FaTrash, FaUpload } from 'react-icons/fa';
import { getImage, removeItem } from '../db/db';

const UploadImage = ({ cardId, onImageUpdate }) => {
  const [image, setImage] = useState(null);

  const clearImage = () => {
    // removeItem
    setImage(null);
    localforage.removeItem('image-'+cardId);
  }

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    const base64 = await readFileAsBase64(file);
    const fileUrl = `data:${file.type};base64,${base64}`;
    setImage(fileUrl);

    try {
      await localforage.setItem('image-'+cardId, fileUrl);
      console.log('Image uploaded successfully');
    } catch (error) {
      console.error('Error uploading image:', error);
    }
  };

  const readFileAsBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(',')[1]);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  const handleClick = () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.addEventListener('change', handleFileChange);
    fileInput.click();
  };

  useEffect(() => {
    getImage({ cardId })
      .then(img => setImage(img))
      .catch(err => console.log(err))
  },[cardId])

  useEffect(() => onImageUpdate(image ? true : false), [image, onImageUpdate]);

  return (
    <div className='flex flex-row gap-2 justify-center items-center'>
      {image && <img src={image} width="96" height={"96"} alt="Card"/>}
      <FaUpload
        style={{fontSize: '3rem'}}
        className="c1 mt-2 p-2 rounded-full border-c1 cursor-pointer"
        onClick={handleClick}
      />
      <FaTrash
        style={{fontSize: '0.8rem'}}
        className="warn mt-2 cursor-pointer"
        onClick={clearImage}
      />
    </div>
  );
};

export default UploadImage;
